import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { PriceFilteringAction } from '@cbridge-packages/price-filtering-profile';

export const closePriceFilteringSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PriceFilteringAction.create.done,
  ),
  map(() => {
    return DetailsSidebarAction.close();
  }),
);
